import { render, staticRenderFns } from "./answer.vue?vue&type=template&id=232b23fc&scoped=true"
import script from "./answer.vue?vue&type=script&lang=js"
export * from "./answer.vue?vue&type=script&lang=js"
import style0 from "./answer.vue?vue&type=style&index=0&id=232b23fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232b23fc",
  null
  
)

export default component.exports